import { render, staticRenderFns } from "./quick-quote-info.vue?vue&type=template&id=6ec126e4&scoped=true&"
import script from "./quick-quote-info.vue?vue&type=script&lang=js&"
export * from "./quick-quote-info.vue?vue&type=script&lang=js&"
import style0 from "./quick-quote-info.vue?vue&type=style&index=0&id=6ec126e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec126e4",
  null
  
)

export default component.exports